// export const checkObjectSections = async (json) => {
//   if (typeof json !== "object" || json === null) {
//     // throw new Error("Invalid JSON: Input is not an object or is null")
//     return false
//   }

//   const expectedKeys = ["receiver", "document", "issuer"]
//   const actualKeys = Object.keys(json)

//   if (expectedKeys.length !== actualKeys.length) {
//     // throw new Error("Invalid JSON: The number of keys does not match the expected keys")
//     return false
//   }

//   for (const key of actualKeys) {
//     if (!expectedKeys.includes(key) || actualKeys.indexOf(key) !== actualKeys.lastIndexOf(key)) {
//       // throw new Error("Invalid JSON: Duplicate or unexpected property found")
//       return false
//     }
//   }

//   return true
// }

/**
 * Checks if the input JSON object conforms to a specific structure.
 *
 * @param {Object} json - The JSON object to check.
 * @returns {boolean} Returns true if the JSON object conforms to the expected structure, or false otherwise.
 */
export const checkObjectSections = async (json) => {
  // Check if the input is not an object or is null
  if (typeof json !== "object" || json === null) {
    // If the input is not an object or is null, return false
    return false
  }

  // Define the expected keys for the JSON object
  const expectedKeys = ["receiver", "document", "issuer"]

  // Get the actual keys from the JSON object
  const actualKeys = Object.keys(json)

  // Check if the number of actual keys matches the number of expected keys
  if (expectedKeys.length !== actualKeys.length) {
    // If the number of keys does not match, return false
    return false
  }

  // Iterate through the actual keys and check for duplicates or unexpected keys
  for (const key of actualKeys) {
    if (!expectedKeys.includes(key) || actualKeys.indexOf(key) !== actualKeys.lastIndexOf(key)) {
      // If duplicate or unexpected property is found, return false
      return false
    }
  }

  // If all checks pass, return true to indicate that the JSON object conforms to the expected structure
  return true
}
